module.exports = ".custom-margin{\r\n    margin-top:30px;\r\n    margin-bottom: 50px;\r\n    }\r\n    .btn-mob-width{\r\n        width: 100%;\r\n        margin-top: 20px;\r\n        margin-bottom: 20px;\r\n    }\r\n    .table td {\r\n        border-top: 0px solid #eceeef;\r\n    }"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/loss-data-dashboard/losses-by-claim-type/large-view/incident-by-loss-type-large-chart.component.css
// module id = ./src/app/modules/loss-data-dashboard/losses-by-claim-type/large-view/incident-by-loss-type-large-chart.component.css
// module chunks = main